// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"92e4b52f","237":"b8150baa","307":"82ddee49","633":"2f3faaff","796":"e4097ce9","861":"c326e2ee","920":"eeb4be02","925":"8603fe0b","966":"7c3fbe9e","992":"c43ab78d"}[chunkId] + ".chunk.js";
};